import styled from 'styled-components';
import { COLORS } from '@/styles/colors';
import { flex } from '@/styles/layout';

export const CountBlock = styled.div`
  width: 100%;
  height: 50px;
  padding: 13px 16px;
  border-radius: 10px;
  border: 1px solid ${COLORS.grey[300]};
  background: ${COLORS.grey[250]};
  ${flex({ justifyContent: 'center', alignItems: 'center' })};
`;
